
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/auth/partnerships/bond",
      function () {
        return require("private-next-pages/docs/auth/partnerships/bond.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/auth/partnerships/bond"])
      });
    }
  